module.exports = __webpack_public_path__ + "static/media/become_member.a5ec698e.jpg";